var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ChatTextDotIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 50,
    glyphHeight: 50
  }), React.createElement("path", {
    d: "M41.3047 0C46.1088 0.000183833 49.9998 3.89123 50 8.69531V31.5215C50 36.3257 46.1089 40.2176 41.3047 40.2178H25L8.69531 50V40.2178C3.89112 40.2176 0 36.3257 0 31.5215V8.69531C0.000183319 3.89123 3.89123 0.000183315 8.69531 0H41.3047ZM8.69531 4.34766C6.29341 4.34784 4.34784 6.29341 4.34766 8.69531V31.5215C4.34766 33.9235 6.29329 35.869 8.69531 35.8691H13.0439V42.3262L22.7607 36.4893L23.7939 35.8691H41.3047C43.7067 35.869 45.6523 33.9235 45.6523 31.5215V8.69531C45.6522 6.29341 43.7066 4.34784 41.3047 4.34766H8.69531ZM11.957 16.3047C14.3591 16.3049 16.3047 18.2503 16.3047 20.6523C16.3046 23.0543 14.359 24.9998 11.957 25C9.55491 25 7.60947 23.0544 7.60938 20.6523C7.60938 18.2502 9.55486 16.3047 11.957 16.3047ZM25 16.3047C27.4022 16.3047 29.3477 18.2502 29.3477 20.6523C29.3476 23.0544 27.4021 25 25 25C22.598 24.9999 20.6524 23.0544 20.6523 20.6523C20.6523 18.2502 22.5979 16.3048 25 16.3047ZM38.0439 16.3047C40.446 16.3049 42.3916 18.2503 42.3916 20.6523C42.3915 23.0543 40.4459 24.9998 38.0439 25C35.6418 25 33.6964 23.0544 33.6963 20.6523C33.6963 18.2502 35.6418 16.3047 38.0439 16.3047Z",
    fill: "black"
  }));
};
export var ChatTextDotIconGlyph = function (props) {
  return React.createElement(ChatTextDotIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};